import {
  askIcon,
  chatStep01,
  chatStep02,
  chatStep03,
  connectIcon,
  images,
  reachIcon,
  searchIcon,
} from "../../images";
import { accountCategoryURL } from "../helpers/constant-words";

export const bannerData = [
  {
    title: "Get client enquiries, ",
    animTitle: `<span class="orange_text">searching just for you in a minute</span>`,
    desc: "",
    ctaText: "Get Early Access",
  },
  {
    title: "Connect instantly ",
    animTitle: `<span class="orange_text">with design professionals <br />near you</span>`,
    desc: "",
    ctaText: "Get Early Access",
  },
  {
    title: "FInd now, the ideal power source ",
    animTitle: `<span class="orange_text">for your style/budget/location</span>`,
    desc: "",
    ctaText: "Get Early Access",
  },
  {
    title: "Search and save connections ",
    animTitle: `<span class="orange_text">for your future needs, at a click</span>`,
    desc: "",
    ctaText: "Get Early Access",
  },
  {
    title: "Build design teams and ",
    animTitle: `<span class="orange_text">find ideal jobs <br />near you</span>`,
    desc: "",
    ctaText: "Get Early Access",
  },
  {
    title: "Find reliable vendors and ",
    animTitle: `<span class="orange_text">consultants for your site location</span>`,
    desc: "",
    ctaText: "Get Early Access",
  },
  {
    title: "Search easily, ",
    animTitle: `<span class="orange_text">Reach more audience &amp; Connect instantly</span>`,
    desc: "",
    ctaText: "Get Early Access",
  },
];

export const perksData = [
  {
    icon: askIcon,
    title: "ASK",
    desc: "anything to design & build",
  },
  {
    icon: searchIcon,
    title: "SEARCH",
    desc: "people & products for projects",
  },
  {
    icon: reachIcon,
    title: "REACH",
    desc: "clients, design events, and sales leads",
  },
  {
    icon: connectIcon,
    title: "CONNECT",
    desc: "with everyone & anyone in the industry",
  },
];

export const builtData = [
  // {
  //   title: "DESIGNERS & CONSULTANTS",
  //   desc: [
  //     {
  //       title: "DESIGNERS & CONSULTANTS",
  //       content:
  //         "<ul><li>Search anything by text / image with Archinza AI™</li><li>Reach more clients</li><li>Find vendors and consultants</li><li>Get Hired & Find Jobs</li></ul>",
  //     },
  //   ],
  // },
  // {
  //   title: "DESIGNERS & CONSULTANTS 222222222222",
  //   desc: [
  //     {
  //       title: "DESIGNERS & CONSULTANTS 222222222",
  //       content:
  //         "<ul><li>Search anything by text / image with Archinza AI™</li><li>Reach more clients</li><li>Find vendors and consultants</li><li>Get Hired & Find Jobs</li></ul>",
  //     },
  //   ],
  // },
  {
    // title: "DESIGNERS & CONSULTANTS",
    title: "DESIGNERS, CONSULTANTS, FREELANCERS & ARTISTS",
    content:
      "<ul><li>Reach more clients</li><li>Find vendors for your projects</li><li>Search by text/image with Archinza AI™</li><li>Hiring & Jobs</li></ul>",
  },
  {
    title: "PRODUCT/MATERIAL VENDORS & BUILDERS",
    content:
      "<ul><li>Reach more clients</li><li>Showcase products & services</li><li>Higher sales conversions</li><li>Get invites to events</li><li>Niche Hiring & Jobs</li></ul>",
  },
  {
    title: "STUDENTS, WORKING PROFESSIONALS & DESIGN ENTHUSIASTS",
    content:
      "<ul><li>Ask anything design & build</li><li>Learn, upskill & get hired</li><li>Search by text/image with Archinza AI™</li><li>Network with top designers</li></ul>",
  },
  // {
  //   title: "Students & Design Enthusiasts",
  //   content:
  //     "<ul><li>Search anything by text/image.</li><li>Get found by clients.</li><li>Connect on demand.</li><li>Niche Hiring & Jobs.</li></ul>",
  // },
];

export const homeFaqData = [
  {
    title: "What is Archinza all about?",
    content:
      "Archinza is an AI-powered Design Assistant built for stakeholders across the Design & Build industry. Whether you have construction or design-related queries or need professional guidance, Archinza provides relevant, real-time answers. From sourcing products, materials, and services to expanding your reach and visibility, the platform helps you search smarter and connect with the right people. In addition, the platform enables personal users to access curated resources, stay updated on industry events, explore career and hiring opportunities, and review businesses and firms. Archinza also offers AI-matched upskilling courses making it a one-stop platform for knowledge, discovery, and growth.",
  },
  {
    title: "Who is Archinza for?",
    content:
      "Archinza is designed for anyone seeking information or connections in the Design & Build industry. Whether you're a creative professional (designer, architect, content creator), a service provider (business owner, contractor, vendor, PR or marketing professional), a material or product seller/distributor, or simply someone passionate about the industry, Archinza is here to empower your journey at every stage.",
  },

  {
    title: `What is the "Ask" feature in Archinza?`,
    content: `<b>The Ask feature (available on Whatsapp) is powered by AI and provides instant, relevant answers to your queries about design, construction, and professional guidance.</b> In the currently available Beta version of Archinza, you can ask about technical details, materials suggestions, methods, project tips, or even mentorship. After the full product you will be able to matchmade recommendations for vendors / consultants / designers or execution teams. <div class="mt-2"> Please note: Archinza AI™  is a model in development, doing its best to provide helpful responses in real time and continuously learning to improve.</div>`,
  },
  {
    title: "How will Archinza benefit me?",
    content:
      "Archinza provides an AI-based matchmaking for products and services, business and sourcing, and opportunities for jobs. With easy WhatsApp adoption, Archinza is quick, easy, hyperlocal and gives equal access to all. It also helps achieve targeted reach for all professionals and businesses in the Design & Build industry at a very low cost.In addition to intelligent search and targeted visibility, Archinza offers personal users with curated design and business resources, updates on industry events, the ability to review businesses and firms and access to personalised upskilling recommendations bringing meaningful value without high marketing or outreach costs."
  },
  {
    title: "Where do I sign up?",
    content: `<a href='${accountCategoryURL}' class='anchor'>Click here</a> to be a part of the Archinza Network`,
  },
  {
    title: "Is Archinza free? ",
    content: `Archinza is currently free for personal accounts during our limited early access phase available only until the full product launch. After that, subscription plans will range between ₹999 and ₹2999, depending on your account type and selected features.
    
    <div class="mt-2"> <b>For Businesses</b> </div>
    We're also offering exclusive free access to our first 1000 business users for the SILVER Plan features —no charges, no catches. Post that, business accounts will be available at ₹ 800- ₹2,500 per month until the full product rollout.

    <div class="mt-2"><a href="${accountCategoryURL}">Click here</a> to get free access to the Archinza Network</div>
    `,
  },
];

// export const noticeData = [
//   {
//     id: 1,
//     date: "18-2-2025",
//     desc: `The global construction robotics market is projected to reach $10.7 billion by 2028.`,
//   },
//   {
//     id: 2,
//     date: "19-2-2025",
//     desc: `97% of mobile users are using AI-powered voice assistants.`,
//   },
//   {
//     id: 3,
//     date: "20-2-2025",
//     desc: `Chatbots responded to 85% of customer service interactions.`,
//   },
//   {
//     id: 4,
//     date: "21-2-2025",
//     desc: "By 2030, the Indian Real-estate market will be valued at $1 trillion.",
//   },
//   {
//     id: 5,
//     date: "22-2-2025",
//     desc: "The architecture, design and construction industry provides a living for more than 25% of the working population in India.",
//   },
//   {
//     id: 6,
//     date: "23-2-2025",
//     desc: `“The human factor still trounces AI,” says RIBA Journal`,
//   },
// ];
export const noticeData = [
  {
    id: 1,
    desc: "AI-powered stakeholder analysis utilizes sentiment analysis and predictive algorithms to foresee and address potential conflicts before they arise.",
  },
  {
    id: 2,
    desc: "AI dramatically improves the speed and accuracy of stakeholder data analysis, processing large datasets far more efficiently than traditional methods.",
  },
  {
    id: 3,
    desc: "Continuous real-time monitoring of stakeholder sentiment allows project managers to stay ahead of concerns and maintain positive relationships.",
  },
  {
    id: 4,
    desc: "Predictive analytics within AI tools help forecast stakeholder reactions, identify key influencers, and anticipate potential conflicts or alliances.",
  },
  {
    id: 5,
    desc: "AI-driven analysis has been shown to prevent significant delays and additional costs in projects by identifying issues early, such as stakeholder dissatisfaction.",
  },
  {
    id: 6,
    desc: "By improving stakeholder alignment and satisfaction, AI has contributed to up to a 40% increase in stakeholder satisfaction during projects.",
  },
  {
    id: 7,
    desc: "AI can identify overlooked stakeholder groups with significant influence, helping project teams reallocate resources and avoid costly mistakes.",
  },
  {
    id: 8,
    desc: "The integration of AI into stakeholder management can reduce risks by providing early warnings and better alignment of resources.",
  },
  {
    id: 9,
    desc: "AI can smooth complex organizational processes, such as mergers, by predicting and addressing potential conflicts between stakeholder groups.",
  },
  {
    id: 10,
    desc: "Data privacy and security are crucial when implementing AI in stakeholder management, with robust protections and regulatory compliance being key factors.",
  },
  {
    id: 11,
    desc: "Resistance to AI adoption is common, but it can be mitigated through stakeholder education, inclusivity in decision-making, and showcasing the benefits through pilot projects.",
  },
  {
    id: 12,
    desc: "Ethical AI use requires regular auditing of algorithms for bias, transparency in decision-making, and ensuring human oversight in AI-driven insights.",
  },
  {
    id: 13,
    desc: "AI is capable of scaling stakeholder management efforts, allowing project teams to manage large numbers of stakeholders efficiently with dynamic, real-time updates.",
  },
  {
    id: 14,
    desc: "A hybrid approach that combines AI with traditional methods allows project managers to benefit from the strengths of both—AI’s data-driven insights and human relationship-building skills.",
  },
  {
    id: 15,
    desc: "AI can significantly reduce project delays in the built environment by improving stakeholder engagement and addressing concerns before they escalate.",
  },
  {
    id: 16,
    desc: "By analyzing past project data, AI can predict stakeholder reactions to changes in building designs, zoning regulations, or construction timelines, helping to prevent conflicts.",
  },
  {
    id: 17,
    desc: "AI tools in construction projects can help identify potential conflicts between contractors, suppliers, local authorities, and the community early in the project cycle, reducing costly disputes.",
  },
  {
    id: 18,
    desc: "Real-time sentiment analysis through AI can help construction project managers track public opinion and community concerns related to environmental impact, leading to more proactive engagement.",
  },
  {
    id: 19,
    desc: "AI can automatically analyze feedback from various stakeholders, including residents, regulatory bodies, and contractors, ensuring that all voices are considered in project planning and execution.",
  },
  {
    id: 20,
    desc: "In large infrastructure projects, AI-driven stakeholder management helps ensure that stakeholders’ needs and concerns are aligned with project goals, minimizing the risk of miscommunication.",
  },
  {
    id: 21,
    desc: "AI-powered tools can predict the impact of design changes on various stakeholders, such as community members or regulatory authorities, helping to avoid delays due to unexpected opposition.",
  },
  {
    id: 22,
    desc: "AI's predictive capabilities enable project managers to identify key influencers within local communities or government bodies, ensuring the right individuals are engaged at critical stages of the project.",
  },
  {
    id: 23,
    desc: "Stakeholder sentiment, including public opinion on urban developments or zoning changes, can be tracked through social media and news monitoring with AI tools, allowing real-time adjustments to engagement strategies.",
  },
  {
    id: 24,
    desc: "AI can optimize resource allocation for stakeholder management by highlighting the most influential stakeholders and determining where engagement efforts should be focused to drive project success.",
  },
  {
    id: 25,
    desc: "Machine learning algorithms can identify patterns in stakeholder behavior, helping project teams anticipate concerns and adjust communication strategies to avoid delays in urban development projects.",
  },
  {
    id: 26,
    desc: "AI can streamline the approval process for large-scale built environment projects by analyzing historical data from regulatory bodies and predicting approval timelines based on previous trends.",
  },
  {
    id: 27,
    desc: "AI helps in understanding the long-term impact of built environment projects on various stakeholders by using historical data, contributing to more sustainable and community-focused planning.",
  },
  {
    id: 28,
    desc: "AI tools can monitor the progress of stakeholder engagement activities, ensuring that all relevant stakeholders, such as environmental groups, local businesses, and residents, are kept informed and involved.",
  },
  {
    id: 29,
    desc: "AI can analyze stakeholder communications to detect early signs of dissatisfaction or opposition in building projects, such as residential developments, helping to prevent costly delays.",
  },
  {
    id: 30,
    desc: "By integrating AI with BIM (Building Information Modeling), project teams can improve stakeholder collaboration by providing real-time updates and insights into project developments.",
  },
  {
    id: 31,
    desc: "AI can automate the tracking of compliance with building codes, zoning laws, and regulatory requirements, ensuring that stakeholder interests, such as those of local governments, are maintained throughout the project.",
  },
  {
    id: 32,
    desc: "In large-scale urban development projects, AI can help assess the social impact of projects, predicting how new developments may affect local communities and stakeholders.",
  },
  {
    id: 33,
    desc: "AI tools can be used to forecast the economic and environmental implications of a building project, helping to align the interests of investors, developers, and regulatory bodies.",
  },
  {
    id: 34,
    desc: "AI’s ability to analyze and predict stakeholder reactions allows for more efficient dispute resolution in the construction and urban planning sectors, saving time and money in the long run.",
  },
  {
    id: 35,
    desc: "Did you know AI can now generate full building designs, complete with structural integrity checks, using generative design tools?",
  },
  {
    id: 36,
    desc: "Parametric design, powered by AI, enables architects to create structures that adapt to site-specific conditions in real-time.",
  },
  {
    id: 37,
    desc: "BIM (Building Information Modeling) software like Revit uses AI to suggest clash-free designs.",
  },
  {
    id: 38,
    desc: "AI algorithms can predict how a building will age, factoring in weather, materials, and location.",
  },
  {
    id: 39,
    desc: "VR and AR are helping architects present immersive walkthroughs to clients before construction begins.",
  },
  {
    id: 40,
    desc: "AI can optimize energy efficiency by simulating daylight and ventilation patterns for sustainable designs.",
  },
  {
    id: 41,
    desc: "AI can analyze historical data to predict the cost-effectiveness of a design before it’s built.",
  },
  {
    id: 42,
    desc: "AI is helping brands predict demand trends for construction materials.",
  },
  {
    id: 43,
    desc: "Vendors can now use AI chatbots to offer real-time product assistance to architects and contractors.",
  },
  {
    id: 44,
    desc: "Digital twins are used by material vendors to provide lifecycle insights into their products.",
  },
  {
    id: 45,
    desc: "3D printing is transforming the way custom materials and building components are manufactured.",
  },
  {
    id: 46,
    desc: "AI enables predictive maintenance of products by analyzing real-time usage data.",
  },
  {
    id: 47,
    desc: "Product vendors are creating AI-powered configurators to customize product offerings instantly.",
  },
  {
    id: 48,
    desc: "Blockchain technology ensures the authenticity of materials and eliminates supply chain fraud.",
  },
  {
    id: 49,
    desc: "Augmented reality is used by vendors to showcase how products fit into real-world projects.",
  },
  {
    id: 50,
    desc: "AI tools are helping vendors offer dynamic pricing based on market trends and demand.",
  },
  {
    id: 51,
    desc: "AI-based sentiment analysis helps media companies gauge public opinion on architectural projects.",
  },
  {
    id: 52,
    desc: "PR agencies use AI-powered tools to target relevant stakeholders with precision.",
  },
  {
    id: 53,
    desc: "Data analytics platforms can track and predict the success of marketing campaigns in real-time.",
  },
  {
    id: 54,
    desc: "AI is transforming influencer marketing by identifying the most relevant voices in the design space.",
  },
  {
    id: 55,
    desc: "Media companies are using AI to translate content into multiple languages instantly.",
  },
  {
    id: 56,
    desc: "PR companies use AI tools to monitor competitors' campaigns and derive actionable insights.",
  },
  {
    id: 57,
    desc: "AI can simulate virtual exhibitions and trade fairs for product launches.",
  },
  {
    id: 58,
    desc: "Predictive analytics helps builders forecast project completion times more accurately.",
  },
  {
    id: 59,
    desc: "Drones, powered by AI, are being used to survey construction sites with centimeter-level accuracy.",
  },
  {
    id: 60,
    desc: "Digital twins allow builders to simulate the entire lifecycle of a building before construction begins.",
  },
  {
    id: 61,
    desc: "IoT sensors in construction sites provide real-time updates on equipment efficiency and worker safety.",
  },
  {
    id: 62,
    desc: "AI platforms are streamlining procurement by predicting material needs based on project schedules.",
  },
  {
    id: 63,
    desc: "Blockchain ensures transparency and accountability across design, build, and supply chains.",
  },
  {
    id: 64,
    desc: "AI-powered tools reduce waste by optimizing the use of raw materials.",
  },
  {
    id: 65,
    desc: "Cloud-based collaboration platforms allow architects, vendors, and builders to work in sync.",
  },
  {
    id: 66,
    desc: "AR-based training modules are upskilling workers to adapt to advanced construction techniques.",
  },
  {
    id: 67,
    desc: "Digital documentation systems eliminate over 80% of paperwork in design and build projects.",
  },
  {
    id: 68,
    desc: "AI can track sustainability metrics, like carbon footprint, throughout a project's lifecycle.",
  },
  {
    id: 69,
    desc: "Robots equipped with AI are performing dangerous tasks, reducing workplace injuries.",
  },
  {
    id: 70,
    desc: "AI-backed systems are ensuring better dispute resolution by analyzing contracts and project data.",
  },
  {
    id: 71,
    desc: "AI can automate the process of identifying and mapping all project stakeholders, streamlining the planning phase and reducing human error.",
  },
  {
    id: 72,
    desc: "AI-powered tools can assess the cultural and social dynamics of local communities, helping urban developers create more contextually sensitive designs and avoid community opposition.",
  },
  {
    id: 73,
    desc: "With AI, construction companies can more accurately predict the financial impact of delays and disruptions, aiding in more precise budgeting and planning.",
  },
  {
    id: 74,
    desc: "AI has helped reduce the number of miscommunications between contractors and stakeholders by offering clearer communication channels and alerts.",
  },
  {
    id: 75,
    desc: "By analyzing large volumes of real-time data, AI tools can optimize building schedules, ensuring that stakeholders' needs for timely deliveries are met.",
  },
  {
    id: 76,
    desc: "AI algorithms can predict potential conflicts based on communication patterns between stakeholders, enabling preemptive actions to be taken to avoid escalation.",
  },
  {
    id: 77,
    desc: "Machine learning models can track and evaluate stakeholder engagement effectiveness, helping project teams refine their strategies for maximum influence.",
  },
  {
    id: 78,
    desc: "AI’s ability to detect trends in stakeholder behavior can help tailor engagement efforts, ensuring the right tone and message is communicated at the right time.",
  },
  {
    id: 79,
    desc: "Natural Language Processing (NLP) enables AI tools to scan written feedback from stakeholders and categorize it based on sentiment, urgency, and topic, allowing for prioritized responses.",
  },
  {
    id: 80,
    desc: "AI-powered predictive models can optimize the timing of construction work to avoid disrupting local businesses, improving relationships with commercial stakeholders.",
  },
  {
    id: 81,
    desc: "AI’s influence on risk management in construction projects has led to a reduction in risk exposure by offering data-driven insights on potential hazards and mitigating actions.",
  },
  {
    id: 82,
    desc: "AI algorithms can help project teams prioritize issues, ensuring that key stakeholders are given attention before their concerns escalate.",
  },
  {
    id: 83,
    desc: "AI in urban planning can simulate the economic benefits and challenges of a project, helping both developers and local authorities make informed decisions about project viability.",
  },
  {
    id: 84,
    desc: "AI tools can be used to forecast changes in stakeholder engagement over time, predicting when certain stakeholders might become more influential or when their concerns may grow.",
  },
  {
    id: 85,
    desc: "AI’s integration with GIS (Geographic Information Systems) allows real-time mapping of stakeholders' proximity to a project site, assisting in better community engagement.",
  },
  {
    id: 86,
    desc: "Predictive maintenance using AI can be extended to construction equipment, ensuring fewer equipment breakdowns and smoother coordination with construction site stakeholders.",
  },
  {
    id: 87,
    desc: "AI tools are increasingly being used by project managers to automate routine communication tasks, reducing human error and enhancing stakeholder satisfaction.",
  },
  {
    id: 88,
    desc: "AI is being used to analyze regulatory trends, helping project teams ensure compliance with evolving local and international standards, thus minimizing conflicts with regulators.",
  },
  {
    id: 89,
    desc: "AI-based platforms are assisting stakeholders by providing accurate, updated project timelines, ensuring that all parties involved are on the same page regarding deadlines.",
  },
  {
    id: 90,
    desc: "AI can help in tracking the environmental and social impacts of construction projects, giving stakeholders more transparent insights into sustainability efforts.",
  },
  {
    id: 91,
    desc: "AI-powered simulations can test building resilience in the face of natural disasters, providing stakeholders with more confidence in long-term project stability.",
  },
  {
    id: 92,
    desc: "AI tools facilitate enhanced collaboration between multiple stakeholders by translating technical language into simpler terms, improving communication and understanding.",
  },
  {
    id: 93,
    desc: "By using AI to analyze demographic data, developers can better tailor projects to the needs and preferences of specific communities, ensuring higher levels of stakeholder support.",
  },
  {
    id: 94,
    desc: "AI can assist in managing large-scale construction projects by automating the scheduling of subcontractors and suppliers, ensuring timely and cost-effective delivery.",
  },
  {
    id: 95,
    desc: "AI-powered platforms allow stakeholders to visualize the potential impact of a project on existing infrastructure, helping them make data-driven decisions about necessary improvements.",
  },
  {
    id: 96,
    desc: "In public infrastructure projects, AI can help identify the economic, social, and environmental trade-offs, allowing for more informed decision-making by stakeholders.",
  },
  {
    id: 97,
    desc: "AI-driven data analysis has improved the accuracy of forecasting construction costs, reducing the likelihood of unexpected budget overruns and minimizing stakeholder frustration.",
  },
  {
    id: 98,
    desc: "AI tools can streamline the process of managing stakeholder feedback by automating the categorization and analysis of public consultations in large-scale urban development projects.",
  },
  {
    id: 99,
    desc: "AI algorithms can assist in identifying potential sources of funding or investors by analyzing the financial goals and priorities of different stakeholders.",
  },
  {
    id: 100,
    desc: "In urban planning, AI tools can simulate different development scenarios, showing stakeholders how varying design choices might affect traffic patterns, public services, and overall community well-being.",
  },
  {
    id: 101,
    desc: "AI can improve the efficiency of public consultations by processing input from various stakeholders quickly and identifying key themes for policymakers to address.",
  },
  {
    id: 102,
    desc: "AI-powered stakeholder engagement platforms allow for interactive, real-time collaboration between project teams and stakeholders, improving the speed and quality of decision-making.",
  },
  {
    id: 103,
    desc: "By using AI to track and analyze public sentiment over time, project managers can adjust communication strategies to ensure continued support from stakeholders throughout a project.",
  },
  {
    id: 104,
    desc: "AI-powered solutions can provide stakeholders with live, data-driven dashboards, ensuring transparency and allowing for informed decision-making throughout the life of a project.",
  },
  {
    id: 105,
    desc: "AI-enhanced geographic mapping systems help project managers assess the impact of a project on surrounding communities, ensuring that construction is as non-disruptive as possible.",
  },
  {
    id: 106,
    desc: "AI can help urban developers predict how new buildings will affect local property values, assisting investors and real estate stakeholders in making more informed decisions.",
  },
  {
    id: 107,
    desc: "AI’s ability to analyze and interpret large volumes of stakeholder communications helps to streamline regulatory approval processes by identifying key issues early on.",
  },
  {
    id: 108,
    desc: "With AI tools in place, project managers can create more accurate environmental impact assessments, reducing the chances of opposition from environmental stakeholders.",
  },
  {
    id: 109,
    desc: "AI can be used to simulate the impact of proposed building designs on traffic and pedestrian flow, helping to identify potential problems for local government stakeholders.",
  },
  {
    id: 110,
    desc: "AI-powered tools help identify and mitigate ethical risks in construction projects, ensuring stakeholders’ interests and concerns are ethically addressed.",
  },
  {
    id: 111,
    desc: "AI tools can support communication strategies by tracking stakeholder interests and suggesting tailored messaging to influence opinions and behavior effectively.",
  },
  {
    id: 112,
    desc: "AI algorithms can determine the most effective timing and method of stakeholder communication based on historical data, increasing the likelihood of successful engagement.",
  },
  {
    id: 113,
    desc: "AI systems are used to assess the environmental footprint of construction materials, giving stakeholders an objective view of the sustainability of building practices.",
  },
  {
    id: 114,
    desc: "In large urban developments, AI-powered predictive tools are used to manage the coordination of multiple stakeholders, ensuring that various interests and needs are balanced.",
  },
  {
    id: 115,
    desc: "By integrating AI with project management software, stakeholders are provided with real-time access to project updates, ensuring alignment and reducing misunderstandings.",
  },
  {
    id: 116,
    desc: "AI-powered decision support systems can recommend optimal solutions for resource allocation, ensuring that stakeholder interests are met in a cost-effective manner.",
  },
  {
    id: 117,
    desc: "AI can facilitate more transparent and efficient public-private partnerships by providing data-driven insights into the progress of large infrastructure projects.",
  },
  {
    id: 118,
    desc: "AI-driven chatbots are increasingly used to address stakeholder inquiries in real time, improving communication and stakeholder satisfaction.",
  },
  {
    id: 119,
    desc: "AI algorithms can be used to predict workforce requirements, ensuring that labor-related stakeholders are effectively managed throughout the project lifecycle.",
  },
  {
    id: 120,
    desc: "AI tools are helping construction teams to track and predict contractor performance, ensuring that stakeholders are kept informed of any potential delays.",
  },
  {
    id: 121,
    desc: "Through AI-powered sentiment analysis, project teams can gauge public opinion about changes to proposed developments, making it easier to adjust the project to meet stakeholder needs.",
  },
  {
    id: 122,
    desc: "AI technology is advancing digital planning tools, allowing stakeholders to interact with 3D models, adjusting designs in real time to better meet community and regulatory needs.",
  },
  {
    id: 123,
    desc: "AI-backed tools in the construction industry help to automate and optimize safety protocols, reducing incidents and enhancing stakeholder confidence in the project.",
  },
  {
    id: 124,
    desc: "AI can assess the economic feasibility of a project by predicting costs and returns over time, helping developers and investors make better-informed decisions.",
  },
  {
    id: 125,
    desc: "AI technologies are improving the speed and accuracy of environmental assessments, ensuring that stakeholders’ concerns about climate impact are addressed early in the process.",
  },
];

export const homeBmoAISteps = [
  {
    icon: chatStep01,
    title: "STEP O1",
    desc: "Chat on WhatsApp",
  },
  {
    icon: chatStep02,
    title: "STEP O2",
    desc: "Ask anything",
  },
  {
    icon: chatStep03,
    title: "STEP O3",
    desc: "Get answers & contacts",
  },
];

export const socialStatusIcons = [
  images.social1.image,
  images.social2.image,
  images.social3.image,
  images.social4.image,
];
